import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsConditions from "./pages/TermsConditions";
import MainLayout from "./layouts/MainLayout";
import { Toaster } from "./components/ui/sonner";
import { ThemeProvider } from "next-themes";

// ✅ Admin
import AdminLayout from "./admin/AdminLayout";
import RequireAdmin from "./admin/RequireAdmin";
import AdminLogin from "./admin/AdminLogin";
import AdminDashboard from "./admin/AdminDashboard";
import AdminLeads from "./pages/admin/AdminLeads";
import AdminClients from "./admin/AdminClients";
import AdminWebsites from "./admin/AdminWebsites";
import AdminInvoices from "./admin/AdminInvoices";
import AdminRenewals from "./admin/AdminRenewals";


function App() {
  return (
    <ThemeProvider attribute="class" defaultTheme="light">
      <BrowserRouter>
        <Routes>
          {/* Public Website */}
          <Route
            path="/*"
            element={
              <MainLayout>
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                  <Route path="/terms-conditions" element={<TermsConditions />} />
				  </Routes>
              </MainLayout>
            }
          />

          {/* Admin */}
          <Route path="/admin/login" element={<AdminLogin />} />
		  <Route path="clients" element={<AdminClients />} />
          <Route
            path="/admin"
            element={
              <RequireAdmin>
                <AdminLayout />
              </RequireAdmin>
            }
          >
            <Route index element={<AdminDashboard />} />
            <Route path="leads" element={<AdminLeads />} />
            <Route path="clients" element={<AdminClients />} />
		    <Route path="websites" element={<AdminWebsites />} />
			<Route path="invoices" element={<AdminInvoices />} />
			<Route path="renewals" element={<AdminRenewals />} />
          </Route>
        </Routes>

        <Toaster />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
